module.exports = __webpack_public_path__ + "img/gd-right-bottom.2d0a71b4.svg";